//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addgameType from "./components/addgameType";
import { loadMoreList } from "@/mixins/index";
export default {
  name: "gameType",
  mixins: [loadMoreList],
  components: {
    addgameType: addgameType
  },
  data: function data() {
    return {
      pagingReqFn: "gameNewsTypes",
      pagingReqValue: "list"
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'delGameType',
        data: {
          id: [data.id]
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};